<template>
<div class="chapter">
<div class="inner_page">
<div class="div_autre">
<div class="pre" id="pre-007">
<h1 class="pre_tit"><span><a id="page_41">Analysis</a></span></h1><a id="page_41">
</a><div class="dev"><a id="page_41">
</a><p class="txt_courant_centre"><a id="page_41"></a><a class="renv" href="#/p1sp1chap1#spart-001"><b>THE BOOK OF THE KING (1 – 37)</b></a></p>
<p class="bl"> </p>
<p class="txt_courant_ssalinea"><a class="renv" href="#/p1sp1chap1#chap-001"><b>1. BACKDROP TO THE MINISTRY OF ISAIAH: THE AUTHOR’S PREFACE (1 – 5)</b></a></p>
<p class="bl"> </p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><a class="renv" href="#/p1sp1chap1#niv1-006">a. Heading (1:1)</a></p>
</li>
<li>
<p class="liste_txt_courant"><a class="renv" href="#/p1sp1chap1#niv1-007">b. A comprehensive failure (1:2–31)</a></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><a class="renv" href="#/p1sp1chap1#niv3-001"><i>i. The national situation (1:2‒9)</i></a></p>
</li>
<li>
<p class="liste_txt_courant"><a class="renv" href="#/p1sp1chap1#niv3-002"><i>ii. The religious situation (1:10‒20)</i></a></p>
</li>
<li>
<p class="liste_txt_courant"><a class="renv" href="#/p1sp1chap1#niv3-003"><i>iii. The social situation and its consequences (1:21‒31)</i></a></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><a class="renv" href="#/p1sp1chap1#niv1-008">c. The ideal, lost and found (2:1 – 4:6)</a></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><a class="renv" href="#/p1sp1chap1#niv3-004"><i>i. Heading (2:1)</i></a></p>
</li>
<li>
<p class="liste_txt_courant"><a class="renv" href="#/p1sp1chap1#niv3-005"><i>ii. The great ‘might have been’ (2:2‒4)</i></a></p>
</li>
<li>
<p class="liste_txt_courant"><a class="renv" href="#/p1sp1chap1#niv3-006"><i>iii. The actual Jerusalem – part one (2:5‒21)</i></a></p>
</li>
<li>
<p class="liste_txt_courant"><a class="renv" href="#/p1sp1chap1#niv3-007"><i>iv. The actual Jerusalem – part two (2:22 ‒ 4:1)</i></a></p>
</li>
<li>
<p class="liste_txt_courant"><a class="renv" href="#/p1sp1chap1#niv3-008"><i>v. The greatness that is ‘yet to be’ (4:2‒6)</i></a></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><a class="renv" href="#/p1sp1chap1#niv1-009">d. Grace exhausted (5:1–30)</a></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><a id="page_42"></a><a class="renv" href="#/p1sp1chap1#niv3-009"><i>i. A total work and a total loss (5:1‒7)</i></a></p>
</li>
<li>
<p class="liste_txt_courant"><a class="renv" href="#/p1sp1chap1#niv3-010"><i>ii. The stink-fruit harvest and its consequence (5:8‒30)</i></a></p>
</li>
</ul>
</li>
</ul>
<p class="bl"> </p>
<p class="txt_courant_ssalinea"><span class="renv" href="#/p1sp1chap2#chap-002" title="Link target outside of Sample"><b>2. LIGHT BEYOND THE DARKNESS: THE COMING KING (6 – 12)</b></span></p>
<p class="bl"> </p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap2#niv1-010" title="Link target outside of Sample">a. The individual, atonement and commission (6:1‒13)</span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap2#niv1-011" title="Link target outside of Sample">b. Darkness and light in Judah (7:1 – 9:7)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap2#niv3-011" title="Link target outside of Sample"><i>i. The moment of decision (7:1‒17)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap2#niv3-012" title="Link target outside of Sample"><i>ii. Divine judgment (7:18 ‒ 8:8)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap2#niv3-013" title="Link target outside of Sample"><i>iii. The believing, obeying remnant (8:9‒22)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap2#niv3-014" title="Link target outside of Sample"><i>iv. The royal hope (9:1‒7)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap2#niv1-013" title="Link target outside of Sample">c. Darkness and light in Israel (9:8 – 11:16)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap2#niv3-015" title="Link target outside of Sample"><i>i. The moment of decision (9:8 ‒ 10:4)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap2#niv3-016" title="Link target outside of Sample"><i>ii. Divine judgment (10:5‒15)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap2#niv3-017" title="Link target outside of Sample"><i>iii. The believing, obeying remnant (10:16‒34)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap2#niv3-018" title="Link target outside of Sample"><i>iv. The royal hope (11:1‒16)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap2#niv1-014" title="Link target outside of Sample">d. The individual in the community: salvation, singing and proclamation (12:1–6)</span></p>
</li>
</ul>
<p class="bl"> </p>
<p class="txt_courant_ssalinea"><span class="renv" href="#/p1sp1chap3#chap-003" title="Link target outside of Sample"><b>3. THE KINGDOM PANORAMA: THE WHOLE WORLD IN HIS HAND (13 – 27)</b></span></p>
<p class="bl"> </p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv1-015" title="Link target outside of Sample">a. The first series of oracles: sure promises (13:1 – 20:6)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-019" title="Link target outside of Sample"><i>i. Babylon: a look behind the scenes (13:1 ‒ 14:27)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-020" title="Link target outside of Sample"><i>ii. Philistia: the Lord’s sure promises to David (14:28‒32)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-021" title="Link target outside of Sample"><i>iii. Moab: salvation refused by pride (15:1 ‒ 16:14)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-022" title="Link target outside of Sample"><i>iv. Damascus/Ephraim: the way of death and the promise of life (17:1 ‒ 18:7)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-023" title="Link target outside of Sample"><i>v. Egypt: one world, one people, one God (19:1 ‒ 20:6)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv1-016" title="Link target outside of Sample">b. The second series of oracles: the long night and the dawn (21 – 23)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-024" title="Link target outside of Sample"><i>i. The desert by the sea: the Babylon principle (21:1‒10)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-025" title="Link target outside of Sample"><i>ii. Silence: days of darkness (21:11‒12)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-026" title="Link target outside of Sample"><i>iii. Desert evening: Gentile needs unsolved (21:13‒17)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-027" title="Link target outside of Sample"><i>iv. The Valley of Vision: the unforgivable sin (22:1‒25)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-028" title="Link target outside of Sample"><i>v. Tyre: holiness to the Lord (23:1‒18)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><a id="page_43"></a><span class="renv" href="#/p1sp1chap3#niv1-017" title="Link target outside of Sample">c. The third series: the world city and the city of God (24:1 – 27:13)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-029" title="Link target outside of Sample"><i>i. The city of meaninglessness (24:1‒20)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-030" title="Link target outside of Sample"><i>ii. Ultimately … the King! (24:21‒23)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-031" title="Link target outside of Sample"><i>iii. Salvation and provision: the world on Mount Zion (25:1‒12)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-032" title="Link target outside of Sample"><i>iv. The strong city (26:1‒21)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap3#niv3-033" title="Link target outside of Sample"><i>v. The universal Israel (27:1‒13)</i></span></p>
</li>
</ul>
</li>
</ul>
<p class="bl"> </p>
<p class="txt_courant_ssalinea"><span class="renv" href="#/p1sp1chap4#chap-004" title="Link target outside of Sample"><b>4. THE LORD OF HISTORY (28 – 37)</b></span></p>
<p class="bl"> </p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap4#niv1-018" title="Link target outside of Sample">a. The six woes (28:1 – 35:10)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap4#niv3-034" title="Link target outside of Sample"><i>i. The first woe: the word of God and the purposes of God (28:1‒29)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap4#niv3-035" title="Link target outside of Sample"><i>ii. The second woe: is anything too hard for the Lord? (29:1‒14)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap4#niv3-036" title="Link target outside of Sample"><i>iii. The third woe: spiritual transformation (29:15‒24)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap4#niv3-037" title="Link target outside of Sample"><i>iv. The fourth woe: faithlessness and faithfulness (30:1‒33)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap4#niv3-038" title="Link target outside of Sample"><i>v. The fifth woe: all things new (31:1 ‒ 32:20)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap4#niv3-039" title="Link target outside of Sample"><i>vi. The sixth woe: home at last (33:1 ‒ 35:10)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap4#niv1-019" title="Link target outside of Sample">b. Epilogue: the rock of history (36:1 – 37:38)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap4#niv3-040" title="Link target outside of Sample"><i>i. The first Assyrian embassy: the helpless king (36:1 ‒ 37:7)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap4#niv3-041" title="Link target outside of Sample"><i>ii. The second Assyrian embassy: the godly king (37:8‒35)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp1chap4#niv3-042" title="Link target outside of Sample"><i>iii. The finale: Assyrian overthrow (37:36‒38)</i></span></p>
</li>
</ul>
</li>
</ul>
<p class="bl"> </p>
<p class="txt_courant_centre"><span class="renv" href="#/p1sp2chap1#spart-002" title="Link target outside of Sample"><b>THE BOOK OF THE SERVANT (38 – 55)</b></span></p>
<p class="bl"> </p>
<p class="txt_courant_ssalinea"><span class="renv" href="#/p1sp2chap1#chap-005" title="Link target outside of Sample"><b>5. HEZEKIAH AND THE WAY OF FAITH: THE DECISIVE SIN (38 – 39)</b></span></p>
<p class="bl"> </p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap1#niv1-020" title="Link target outside of Sample">a. One prayer, two answers (38:1–8)</span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap1#niv1-021" title="Link target outside of Sample">b. Death and life (38:9–22)</span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap1#niv1-023" title="Link target outside of Sample">c. The moment of decision (39:1–8)</span></p>
</li>
</ul>
<p class="bl"> </p>
<p class="txt_courant_ssalinea"><span class="renv" href="#/p1sp2chap2#chap-006" title="Link target outside of Sample"><b>6. UNIVERSAL CONSOLATION (40:1 – 42:17)</b></span></p>
<p class="bl"> </p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap2#niv1-024" title="Link target outside of Sample">a. Consolation for the Lord’s people (40:1 – 41:20)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap2#niv3-043" title="Link target outside of Sample"><i>i. The message of comfort (40:1‒11)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap2#niv3-044" title="Link target outside of Sample"><i>ii. God the Creator, guarantor of his promises (40:12‒31)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap2#niv3-045" title="Link target outside of Sample"><i>iii. God the world ruler, guarantor of his promises (41:1‒7)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap2#niv3-046" title="Link target outside of Sample"><i>iv. Three pictures: guaranteed consolations (41:8‒20)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><a id="page_44"></a><span class="renv" href="#/p1sp2chap2#niv1-025" title="Link target outside of Sample">b. Gentile hope (41:21 – 42:17)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap2#niv3-047" title="Link target outside of Sample"><i>i. Summoned before the court: the plight of the Gentile world (41:21‒29)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap2#niv3-048" title="Link target outside of Sample"><i>ii. The Servant: the great solution (42:1‒9)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap2#niv3-049" title="Link target outside of Sample"><i>iii. Singing world, saving Lord (42:10‒17)</i></span></p>
</li>
</ul>
</li>
</ul>
<p class="bl"> </p>
<p class="txt_courant_ssalinea"><span class="renv" href="#/p1sp2chap3#chap-007" title="Link target outside of Sample"><b>7. THE LORD’S PLAN UNFOLDED (42:18 – 44:23)</b></span></p>
<p class="bl"> </p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap3#niv1-026" title="Link target outside of Sample">a. Israel’s bondage and liberation (42:18 – 43:21)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap3#niv3-050" title="Link target outside of Sample"><i>i. The blind servant (42:18‒25)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap3#niv3-051" title="Link target outside of Sample"><i>ii. Unchanged divine care (43:1‒7)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap3#niv3-052" title="Link target outside of Sample"><i>iii. No other God: sure promises (43:8‒13)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap3#niv3-053" title="Link target outside of Sample"><i>iv. A new exodus: the problem of bondage solved (43:14‒21)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap3#niv1-027" title="Link target outside of Sample">b. Israel’s sin and redemption (43:22 – 44:23)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap3#niv3-054" title="Link target outside of Sample"><i>i. Diagnosis (43:22‒24)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap3#niv3-055" title="Link target outside of Sample"><i>ii. Remedy (43:25 ‒ 44:5)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap3#niv3-056" title="Link target outside of Sample"><i>iii. No other God: sure promises (44:6‒20)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap3#niv3-057" title="Link target outside of Sample"><i>iv. Redemption from sin (44:21‒23)</i></span></p>
</li>
</ul>
</li>
</ul>
<p class="bl"> </p>
<p class="txt_courant_ssalinea"><span class="renv" href="#/p1sp2chap4#chap-008" title="Link target outside of Sample"><b>8. THE GREAT DELIVERANCE: THE WORK OF CYRUS (44:24 – 48:22)</b></span></p>
<p class="bl"> </p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap4#niv1-028" title="Link target outside of Sample">a. Cyrus: builder and conqueror (44:24 – 45:8)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap4#niv3-058" title="Link target outside of Sample"><i>i. The Lord and his word (44:24‒26b)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap4#niv3-059" title="Link target outside of Sample"><i>ii. The Lord and his purpose (44:26c–28)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap4#niv3-060" title="Link target outside of Sample"><i>iii. The Lord and his anointed (45:1‒7)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap4#niv3-061" title="Link target outside of Sample"><i>iv. The Lord and his creative resolve (45:8)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap4#niv1-030" title="Link target outside of Sample">b. Rebellion and resolve, quibbling and consolation (45:9 – 46:13)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap4#niv3-062" title="Link target outside of Sample"><i>i. The potter and the parent (45:9‒13)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap4#niv3-063" title="Link target outside of Sample"><i>ii. An unchanged worldwide purpose for Israel (45:14‒25)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap4#niv3-064" title="Link target outside of Sample"><i>iii. The unchanging Lord and his stubborn rebels (46:1‒13)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap4#niv1-031" title="Link target outside of Sample">c. Free at last (47:1 – 48:22)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap4#niv3-065" title="Link target outside of Sample"><i>i. Pride before a fall (47:1‒15)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap4#niv3-066" title="Link target outside of Sample"><i>ii. Home, yet not home (48:1‒22)</i></span></p>
</li>
</ul>
</li>
</ul>
<p class="bl"> </p>
<p class="txt_courant_ssalinea"><a id="page_45"></a><span class="renv" href="#/p1sp2chap5#chap-009" title="Link target outside of Sample"><b>9. THE GREATER DELIVERANCE: THE WORK OF THE SERVANT (49 – 55)</b></span></p>
<p class="bl"> </p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap5#niv1-032" title="Link target outside of Sample">a. The Servant’s double task (49:1–6)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap5#niv3-067" title="Link target outside of Sample"><i>i. The first testimony: Israel as it was meant to be (49:1‒3)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap5#niv3-068" title="Link target outside of Sample"><i>ii. The second testimony: the Agent, the task and the result (49:4‒6)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap5#niv1-033" title="Link target outside of Sample">b. Divine confirmation: worldwide success (49:7–13)</span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap5#niv1-034" title="Link target outside of Sample">c. Nation and Servant, a contrast: unresponding and responding (49:14 – 50:11)</span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap5#niv1-035" title="Link target outside of Sample">d. Salvation in prospect: the watching remnant (51:1 – 52:12)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap5#niv3-069" title="Link target outside of Sample"><i>i. Commands to listen: promises of salvation (51:1‒8)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap5#niv3-070" title="Link target outside of Sample"><i>ii. A dramatic appeal: exodus past and future (51:9‒11)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap5#niv3-071" title="Link target outside of Sample"><i>iii. Interlude: a final briefing (51:12‒16)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap5#niv3-072" title="Link target outside of Sample"><i>iv. Commands to respond: what the Lord has done (51:17 ‒ 52:12)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap5#niv1-036" title="Link target outside of Sample">e. Worldwide salvation (52:13 – 55:13)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap5#niv3-073" title="Link target outside of Sample"><i>i. The triumph of the Servant (52:13 ‒ 53:12)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp2chap5#niv3-074" title="Link target outside of Sample"><i>ii. The great invitation (54:1 ‒ 55:13)</i></span></p>
</li>
</ul>
</li>
</ul>
<p class="bl"> </p>
<p class="txt_courant_centre"><span class="renv" href="#/p1sp3dev1#spart-003" title="Link target outside of Sample"><b>THE BOOK OF THE CONQUEROR (56 – 66)</b></span></p>
<p class="bl"> </p>
<p class="txt_courant_ssalinea"><span class="renv" href="#/p1sp3chap2#chap-010" title="Link target outside of Sample"><b>10. THE IDEAL AND THE ACTUAL: THE LORD’S NEEDY, UNDER-ACHIEVING PEOPLE (56:1 – 59:13)</b></span></p>
<p class="bl"> </p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap2#niv1-037" title="Link target outside of Sample">a. The waiting people (56:1–8)</span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap2#niv1-038" title="Link target outside of Sample">b. The divided people (56:9 – 57:21)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap2#niv3-075" title="Link target outside of Sample"><i>i. The failure of the leaders (56:9‒12)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap2#niv3-076" title="Link target outside of Sample"><i>ii. The prostitute’s brood and the Lord’s household (57:1‒21)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap2#niv1-039" title="Link target outside of Sample">c. The Sabbath people (58:1–14)</span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap2#niv1-040" title="Link target outside of Sample">d. The guilty people (59:1–13)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap2#niv3-077" title="Link target outside of Sample"><i>i. Accusations (59:1‒4)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap2#niv3-078" title="Link target outside of Sample"><i>ii. Descriptions (59:5‒8)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap2#niv3-079" title="Link target outside of Sample"><i>iii. Confessions (59:9‒13)</i></span></p>
</li>
</ul>
</li>
</ul>
<p class="bl"> </p>
<p class="txt_courant_ssalinea"><span class="renv" href="#/p1sp3chap3#chap-011" title="Link target outside of Sample"><b>11. THE PROMISED CONQUEROR: VENGEANCE AND SALVATION (59:14 – 63:6)</b></span></p>
<p class="bl"> </p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap3#niv1-041" title="Link target outside of Sample">a. Preface: situation and remedy (59:14–20)</span></p>
</li>
<li>
<p class="liste_txt_courant"><a id="page_46"></a><span class="renv" href="#/p1sp3chap3#niv1-042" title="Link target outside of Sample">b. The Covenant Mediator and his achievement (59:21 – 60:22)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap3#niv3-080" title="Link target outside of Sample"><i>i. The Covenant Mediator (59:21)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap3#niv3-081" title="Link target outside of Sample"><i>ii. The universal city (60:1‒22)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap3#niv1-043" title="Link target outside of Sample">c. The Anointed One and his transforming work (61:1–9)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap3#niv3-082" title="Link target outside of Sample"><i>i. First testimony of the Anointed One: transformation (61:1‒4)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap3#niv3-083" title="Link target outside of Sample"><i>ii. Transformation confirmed (61:5‒9)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap3#niv1-044" title="Link target outside of Sample">d. The Saviour and his gathered people (61:10 – 62:12)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap3#niv3-084" title="Link target outside of Sample"><i>i. Second testimony: acceptance of the role of Saviour (61:10 ‒ 62:7)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap3#niv3-085" title="Link target outside of Sample"><i>ii. The Lord’s oath, summons and proclamation (62:8‒12)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap3#niv1-045" title="Link target outside of Sample">e. The consummation: the Anointed One completes his task (63:1–6)</span></p>
</li>
</ul>
<p class="bl"> </p>
<p class="txt_courant_ssalinea"><span class="renv" href="#/p1sp3chap4#chap-012" title="Link target outside of Sample"><b>12. THE NEW HEAVEN AND NEW EARTH: PRAYERS AND PROMISES (63:7 – 66:24)</b></span></p>
<p class="bl"> </p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap4#niv1-046" title="Link target outside of Sample">a. A ‘remembrancer’ at prayer (63:7 – 64:12)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap4#niv3-086" title="Link target outside of Sample"><i>i. Remembering (63:7‒14)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap4#niv3-087" title="Link target outside of Sample"><i>ii. Asking (63:15 ‒ 64:12)</i></span></p>
</li>
</ul>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap4#niv1-047" title="Link target outside of Sample">b. The Lord responding: sure promises, coming consummation (65:1 – 66:24)</span></p>
<ul class="liste_none">
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap4#niv3-088" title="Link target outside of Sample"><i>i. Pleading and provocation (65:1‒10)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap4#niv3-089" title="Link target outside of Sample"><i>ii. Contrasting destinies (65:11‒16)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap4#niv3-090" title="Link target outside of Sample"><i>iii. All things new (65:17‒25)</i></span></p>
</li>
<li>
<p class="liste_txt_courant"><span class="renv" href="#/p1sp3chap4#niv3-091" title="Link target outside of Sample"><i>iv. Judgment and hope (66:1‒24)</i></span></p>
</li>
</ul>
</li>
</ul>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre8.vue?6fe5d64d